import { CarouselComponent } from 'components/main/carousel/carousel.component'
export default CarouselComponent
